module.exports = ".side-nav {\n  border-right: 1px solid #e0e0e0;\n}\n#content {\n  padding: 20px;\n}\n"